import { render, staticRenderFns } from "./TimeHandling.vue?vue&type=template&id=1c771a2d"
import script from "./TimeHandling.vue?vue&type=script&lang=js"
export * from "./TimeHandling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports